import { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../services/firebase';
import { getPasswordResetErrorMessage } from '../../utils';

/**
 * 비밀번호 재설정 관련 로직을 담당하는 커스텀 훅
 * @returns {object} - 비밀번호 재설정 관련 상태와 함수들
 */
export const usePasswordReset = () => {
  const [resetPasswordMode, setResetPasswordMode] = useState(false);
  const [resetPasswordEmail, setResetPasswordEmail] = useState('');
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState('');

  /**
   * 비밀번호 재설정 이메일 발송 함수
   * @param {string} email - 재설정할 이메일 주소
   * @returns {Promise<boolean>} - 성공 여부
   */
  const handlePasswordReset = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      setResetPasswordSuccess(true);
      setResetPasswordError('');
      return true;
    } catch (e) {
      const errorMessage = getPasswordResetErrorMessage(e.code);
      setResetPasswordError(errorMessage);
      setResetPasswordSuccess(false);
      return false;
    }
  };

  /**
   * 비밀번호 재설정 상태 초기화 함수
   */
  const resetPasswordResetState = () => {
    setResetPasswordMode(false);
    setResetPasswordEmail('');
    setResetPasswordSuccess(false);
    setResetPasswordError('');
  };

  return {
    // 상태
    resetPasswordMode,
    setResetPasswordMode,
    resetPasswordEmail,
    setResetPasswordEmail,
    resetPasswordSuccess,
    resetPasswordError,
    
    // 함수
    handlePasswordReset,
    resetPasswordResetState
  };
}; 